import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/* ───────────── DATA ───────────── */
const shareablePlans = [
  {
    id: "s-incubate",
    tier: "INCUBATING",
    name: "인큐베이팅형",
    badge: null,
    tagline: "아르트레너 전액 투자",
    initInvest: "0원",
    shareRate: "40 – 50%",
    paymentNote: "초기 납부 없음 · 수익 발생 후 정산",
    accentColor: "#F97316",
    glowColor: "rgba(249,115,22,0.18)",
    borderColor: "rgba(249,115,22,0.25)",
    icon: "ri-fire-line",
    description:
      "초기 자본이 없어도 시작 가능. 아르트레너가 모든 비용을 전액 투자하고 성과가 발생했을 때 수익을 함께 나눕니다. 높은 심사 기준이 적용됩니다.",
    features: [
      "풀 플랫폼 빌딩 기본 포함",
      "초기 투자금 전액 아르트레너 부담",
      "전용 인큐베이팅 6개월 프로그램",
      "투자사 네트워크 공동 접근",
      "1:1 전략 컨설팅 (주 1회)",
      "법무 · 회계 백오피스 포함",
    ],
    cta: "인큐베이팅 지원하기",
    highlighted: false,
    barWidth: "85%",
  },
  {
    id: "s-partner",
    tier: "PARTNER",
    name: "파트너형",
    badge: "MOST POPULAR",
    tagline: "리스크 분담형 공동성장",
    initInvest: "300 – 500만원",
    shareRate: "25 – 30%",
    paymentNote: "착수금 50% · 잔금 50% 분할",
    accentColor: "#A855F7",
    glowColor: "rgba(168,85,247,0.22)",
    borderColor: "rgba(168,85,247,0.5)",
    icon: "ri-shake-hands-line",
    description:
      "아르트레너와 함께 리스크를 분담하는 공동성장 모델. 가장 균형 잡힌 투자·수익 구조로 초기 부담을 줄이면서 높은 성장 지원을 받을 수 있습니다.",
    features: [
      "풀 플랫폼 빌딩 기본 포함",
      "브랜드 & IP 보호 전략",
      "GTM 전략 & 런칭 지원",
      "팝업 스토어 · 전시 공동 기획",
      "투자 유치 · IR 피칭 지원",
      "전담 빌더 매니저 + 월간 리포트",
    ],
    cta: "파트너 플랜 신청",
    highlighted: true,
    barWidth: "52%",
  },
  {
    id: "s-scale",
    tier: "SCALE-UP",
    name: "스케일업형",
    badge: null,
    tagline: "자체 자본 보유 아티스트용",
    initInvest: "협의 후 결정",
    shareRate: "10 – 15%",
    paymentNote: "납부 방식 별도 협의",
    accentColor: "#14F1D9",
    glowColor: "rgba(20,241,217,0.15)",
    borderColor: "rgba(20,241,217,0.22)",
    icon: "ri-seedling-line",
    description:
      "자체 자본 보유 아티스트가 IT·법무·마케팅 역량을 아웃소싱하고 싶을 때 최적. 초기 투자 부담이 높은 대신 수익 쉐어 비율이 가장 낮습니다.",
    features: [
      "풀 플랫폼 빌딩 기본 포함",
      "브랜드 & IP 보호 전략",
      "GTM 전략 & 런칭 지원",
      "법무 · 회계 백오피스",
      "마케팅 캠페인 실행",
    ],
    cta: "스케일업 플랜 신청",
    highlighted: false,
    barWidth: "20%",
  },
];

const directPlans = [
  {
    id: "d-single",
    tier: "SINGLE CHANNEL",
    name: "싱글 채널",
    badge: null,
    tagline: "하나의 채널을 완벽하게",
    price: "700만원~",
    priceNote: "단일 채널 기준 · 분할 가능",
    accentColor: "#14F1D9",
    glowColor: "rgba(20,241,217,0.15)",
    borderColor: "rgba(20,241,217,0.22)",
    icon: "ri-focus-3-line",
    complexityDots: 2,
    duration: "1주",
    teamSize: "빌더 1인",
    installments: [
      { label: "착수금", pct: 50 },
      { label: "잔금", pct: 50 },
    ],
    description:
      "쇼핑몰 · 랜딩페이지 · 앱 중 하나에 집중해 완성도 높게 납품합니다. 범위가 명확하고 빠른 런칭이 필요할 때 최적입니다.",
    features: [
      "단일 채널 기획 · 디자인 · 개발",
      "브랜드 아이덴티티 기본 적용",
      "결제 · 재고 · 기본 연동 세팅",
      "SNS 채널 초기 세팅",
    ],
    cta: "싱글 채널 문의",
    highlighted: false,
  },
  {
    id: "d-multi",
    tier: "MULTI CHANNEL",
    name: "멀티 채널",
    badge: "RECOMMENDED",
    tagline: "브랜드 + 판매 + 마케팅 한 번에",
    price: "1,500만원~",
    priceNote: "멀티 채널 기준 · 분할 가능",
    accentColor: "#A855F7",
    glowColor: "rgba(168,85,247,0.22)",
    borderColor: "rgba(168,85,247,0.5)",
    icon: "ri-layout-grid-line",
    complexityDots: 4,
    duration: "2주",
    teamSize: "빌더 2 – 3인",
    installments: [
      { label: "착수금", pct: 30 },
      { label: "중도금", pct: 40 },
      { label: "잔금", pct: 30 },
    ],
    description:
      "쇼핑몰 + 브랜드 사이트 + 마케팅 채널을 동시에 구축. 복수의 채널이 유기적으로 연결된 풀 브랜드 인프라를 만듭니다.",
    features: [
      "브랜드 전략 + 아이덴티티 풀 패키지",
      "D2C 쇼핑몰 + 브랜드 사이트 동시 구축",
      "SNS · 뉴스레터 · 광고 채널 연동",
      "GTM 전략 & 런칭 캠페인 실행",
      "법무 · 회계 백오피스 2개월",
      "전담 PM 배정",
    ],
    cta: "멀티 채널 문의",
    highlighted: true,
  },
  {
    id: "d-platform",
    tier: "FULL PLATFORM",
    name: "풀 플랫폼",
    badge: null,
    tagline: "복합 기능 · 커스텀 플랫폼 구축",
    price: "별도 견적",
    priceNote: "기능 범위 · 복잡도에 따라",
    accentColor: "#F97316",
    glowColor: "rgba(249,115,22,0.15)",
    borderColor: "rgba(249,115,22,0.22)",
    icon: "ri-stack-line",
    complexityDots: 5,
    duration: "4주",
    teamSize: "전담 팀 편성",
    installments: [
      { label: "착수금", pct: 30 },
      { label: "중도금", pct: 40 },
      { label: "잔금", pct: 30 },
    ],
    description:
      "멤버십·커뮤니티·앱·복수 국가 대응 등 고복잡도 플랫폼 요구사항에 대응. 기능 범위와 공수를 협의 후 맞춤 견적을 제안합니다.",
    features: [
      "멀티 채널 전 항목 포함",
      "커스텀 기능 설계 · 개발 (제한 없음)",
      "멤버십 · 커뮤니티 · 앱 대응",
      "복수 국가 / 다국어 대응",
      "팝업 스토어 · 전시 공동 기획",
      "전담 빌더 매니저 배정",
    ],
    cta: "플랫폼 상담 신청",
    highlighted: false,
  },
];

/* ───────────── SUB-COMPONENTS ───────────── */
interface SharePlanCardProps {
  plan: (typeof shareablePlans)[0];
  hovered: string | null;
  onHover: (id: string | null) => void;
}

function SharePlanCard({ plan, hovered, onHover }: SharePlanCardProps) {
  const active = hovered === plan.id || plan.highlighted;
  return (
    <div
      onMouseEnter={() => onHover(plan.id)}
      onMouseLeave={() => onHover(null)}
      className={`relative rounded-3xl flex flex-col transition-all duration-300 cursor-pointer ${
        plan.highlighted ? "md:scale-[1.03] md:z-10" : ""
      }`}
      style={{
        border: `1px solid ${plan.borderColor}`,
        background: plan.highlighted
          ? "linear-gradient(160deg, rgba(168,85,247,0.12) 0%, rgba(6,8,15,0.9) 60%)"
          : "rgba(13,17,32,0.8)",
        boxShadow: active
          ? `0 0 40px ${plan.glowColor}, 0 0 80px ${plan.glowColor.replace("0.22", "0.08").replace("0.18","0.07").replace("0.15","0.06")}`
          : "none",
      }}
    >
      <div className={`p-7 lg:p-9 flex flex-col gap-6 h-full ${plan.badge ? "pt-12" : ""}`}>
        {plan.badge && (
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
            <span
              className="px-4 py-1.5 rounded-full text-xs font-display font-bold text-white tracking-widest whitespace-nowrap"
              style={{ background: "linear-gradient(90deg, #A855F7, #7C3AED)" }}
            >
              {plan.badge}
            </span>
          </div>
        )}

        {/* icon + labels */}
        <div>
          <div
            className="w-11 h-11 flex items-center justify-center rounded-2xl mb-4"
            style={{ background: plan.glowColor, border: `1px solid ${plan.accentColor}30` }}
          >
            <i className={`${plan.icon} text-lg`} style={{ color: plan.accentColor }} />
          </div>
          <span className="text-xs font-display font-bold tracking-widest" style={{ color: plan.accentColor }}>
            {plan.tier}
          </span>
          <h3 className="font-display text-xl font-bold text-white mt-1.5">{plan.name}</h3>
          <p className="text-xs text-white/40 mt-0.5">{plan.tagline}</p>
        </div>

        {/* pricing box */}
        <div
          className="p-5 rounded-2xl"
          style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}
        >
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs text-white/40 font-body">초기 투자금</span>
            <span className="text-sm font-display font-semibold text-white">{plan.initInvest}</span>
          </div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs text-white/40 font-body">수익 쉐어율</span>
            <span className="text-lg font-display font-bold" style={{ color: plan.accentColor }}>
              {plan.shareRate}
            </span>
          </div>
          <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{ width: plan.barWidth, background: `linear-gradient(to right, ${plan.accentColor}, ${plan.accentColor}70)` }}
            />
          </div>
          <div className="flex justify-between mt-2">
            <span className="text-xs text-white/20">쉐어율 낮음</span>
            <span className="text-xs text-white/20">쉐어율 높음</span>
          </div>
          {/* Full platform chip */}
          <div
            className="mt-3 flex items-center gap-2 px-3 py-2 rounded-xl"
            style={{ background: "rgba(20,241,217,0.06)", border: "1px solid rgba(20,241,217,0.2)" }}
          >
            <i className="ri-stack-line text-xs flex-shrink-0" style={{ color: "#14F1D9" }} />
            <span className="text-xs font-body font-medium" style={{ color: "#14F1D9" }}>
              풀 플랫폼 빌딩 기본 포함
            </span>
          </div>
          {/* Payment note */}
          <div className="mt-2.5 flex items-center gap-2 pt-2.5 border-t border-white/5">
            <i className="ri-calendar-schedule-line text-xs text-white/25 flex-shrink-0" />
            <span className="text-xs text-white/40 font-body">{plan.paymentNote}</span>
          </div>
        </div>

        <p className="text-sm text-white/50 font-body leading-relaxed">{plan.description}</p>

        <ul className="flex flex-col gap-3 flex-1">
          {plan.features.map((f, idx) => (
            <li
              key={f}
              className={`flex items-start gap-3 text-sm ${
                idx === 0 ? "font-semibold text-white/90" : "text-white/70"
              }`}
            >
              <i
                className={`mt-0.5 flex-shrink-0 ${idx === 0 ? "ri-stack-line" : "ri-check-line"}`}
                style={{ color: plan.accentColor }}
              />
              {f}
            </li>
          ))}
        </ul>

        <a
          href={`/diagnosis?planType=share&planTier=${plan.id.replace("s-", "")}`}
          className="mt-auto flex items-center justify-center gap-2 py-4 rounded-2xl text-sm font-display font-semibold text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={
            plan.highlighted
              ? { background: "linear-gradient(135deg, #A855F7, #7C3AED)", boxShadow: "0 0 20px rgba(168,85,247,0.35)" }
              : { background: "rgba(255,255,255,0.05)", border: `1px solid ${plan.accentColor}30` }
          }
        >
          {plan.cta}
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </div>
  );
}

interface DirectPlanCardProps {
  plan: (typeof directPlans)[0];
  hovered: string | null;
  onHover: (id: string | null) => void;
}

function DirectPlanCard({ plan, hovered, onHover }: DirectPlanCardProps) {
  const active = hovered === plan.id || plan.highlighted;
  const totalDots = 5;
  return (
    <div
      onMouseEnter={() => onHover(plan.id)}
      onMouseLeave={() => onHover(null)}
      className={`relative rounded-3xl flex flex-col transition-all duration-300 cursor-pointer ${
        plan.highlighted ? "md:scale-[1.03] md:z-10" : ""
      }`}
      style={{
        border: `1px solid ${plan.borderColor}`,
        background: plan.highlighted
          ? "linear-gradient(160deg, rgba(168,85,247,0.12) 0%, rgba(6,8,15,0.9) 60%)"
          : "rgba(13,17,32,0.8)",
        boxShadow: active
          ? `0 0 40px ${plan.glowColor}, 0 0 80px ${plan.glowColor.replace("0.22", "0.08").replace("0.15","0.06")}`
          : "none",
      }}
    >
      <div className={`p-7 lg:p-9 flex flex-col gap-6 h-full ${plan.badge ? "pt-12" : ""}`}>
        {plan.badge && (
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
            <span
              className="px-4 py-1.5 rounded-full text-xs font-display font-bold text-white tracking-widest whitespace-nowrap"
              style={{ background: "linear-gradient(90deg, #A855F7, #7C3AED)" }}
            >
              {plan.badge}
            </span>
          </div>
        )}

        {/* icon + labels */}
        <div>
          <div
            className="w-11 h-11 flex items-center justify-center rounded-2xl mb-4"
            style={{ background: plan.glowColor, border: `1px solid ${plan.accentColor}30` }}
          >
            <i className={`${plan.icon} text-lg`} style={{ color: plan.accentColor }} />
          </div>
          <span className="text-xs font-display font-bold tracking-widest" style={{ color: plan.accentColor }}>
            {plan.tier}
          </span>
          <h3 className="font-display text-xl font-bold text-white mt-1.5">{plan.name}</h3>
          <p className="text-xs text-white/40 mt-0.5">{plan.tagline}</p>
        </div>

        {/* complexity + meta box */}
        <div
          className="p-5 rounded-2xl flex flex-col gap-4"
          style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}
        >
          {/* Complexity meter */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-white/40 font-body">솔루션 규모</span>
              <span className="text-xs font-display font-semibold" style={{ color: plan.accentColor }}>
                {plan.complexityDots === 2 ? "소규모" : plan.complexityDots === 4 ? "중규모" : "대규모 · 복합"}
              </span>
            </div>
            <div className="flex gap-1.5">
              {Array.from({ length: totalDots }).map((_, i) => (
                <div
                  key={i}
                  className="flex-1 h-2 rounded-full transition-all duration-300"
                  style={{
                    background: i < plan.complexityDots
                      ? `linear-gradient(to right, ${plan.accentColor}, ${plan.accentColor}90)`
                      : "rgba(255,255,255,0.07)",
                  }}
                />
              ))}
            </div>
          </div>

          {/* Duration + Team */}
          <div className="flex gap-3">
            <div
              className="flex-1 flex items-center gap-2 px-3 py-2.5 rounded-xl"
              style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)" }}
            >
              <i className="ri-time-line text-xs text-white/30 flex-shrink-0" />
              <div>
                <p className="text-xs text-white/25 mb-0.5">예상 공수</p>
                <p className="text-xs font-display font-semibold text-white/80">{plan.duration}</p>
              </div>
            </div>
            <div
              className="flex-1 flex items-center gap-2 px-3 py-2.5 rounded-xl"
              style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)" }}
            >
              <i className="ri-team-line text-xs text-white/30 flex-shrink-0" />
              <div>
                <p className="text-xs text-white/25 mb-0.5">팀 편성</p>
                <p className="text-xs font-display font-semibold text-white/80">{plan.teamSize}</p>
              </div>
            </div>
          </div>

          {/* Price row */}
          <div className="flex items-end justify-between pt-1 border-t border-white/5">
            <div>
              <p className="text-xs text-white/30 font-body mb-0.5">개발비</p>
              <span className="text-2xl font-display font-bold text-white">{plan.price}</span>
            </div>
            <div
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl"
              style={{ background: "rgba(20,241,217,0.07)", border: "1px solid rgba(20,241,217,0.2)" }}
            >
              <i className="ri-shield-check-line text-xs" style={{ color: "#14F1D9" }} />
              <span className="text-xs font-body font-medium whitespace-nowrap" style={{ color: "#14F1D9" }}>
                수익 쉐어 없음
              </span>
            </div>
          </div>

          {/* Installment bar */}
          <div className="pt-3 border-t border-white/5">
            <p className="text-xs text-white/30 font-body mb-2.5 flex items-center gap-1.5">
              <i className="ri-calendar-schedule-line" />
              납부 조건
            </p>
            <div className="flex rounded-lg overflow-hidden h-6 gap-0.5">
              {plan.installments.map((inst, i) => (
                <div
                  key={i}
                  className="flex items-center justify-center text-xs font-display font-bold"
                  style={{
                    width: `${inst.pct}%`,
                    background:
                      i === 0
                        ? `${plan.accentColor}55`
                        : i === 1 && plan.installments.length === 3
                        ? `${plan.accentColor}35`
                        : `${plan.accentColor}20`,
                    color: plan.accentColor,
                  }}
                >
                  {inst.pct}%
                </div>
              ))}
            </div>
            <div className="flex mt-1.5 gap-0.5">
              {plan.installments.map((inst, i) => (
                <div
                  key={i}
                  className="text-center"
                  style={{ width: `${inst.pct}%` }}
                >
                  <span className="text-xs text-white/35 font-body">{inst.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="text-sm text-white/50 font-body leading-relaxed">{plan.description}</p>

        <ul className="flex flex-col gap-3 flex-1">
          {plan.features.map((f) => (
            <li key={f} className="flex items-start gap-3 text-sm text-white/70">
              <i className="ri-check-line mt-0.5 flex-shrink-0" style={{ color: plan.accentColor }} />
              {f}
            </li>
          ))}
        </ul>

        <a
          href={`/diagnosis?planType=direct&planTier=${plan.id.replace("d-", "")}`}
          className="mt-auto flex items-center justify-center gap-2 py-4 rounded-2xl text-sm font-display font-semibold text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={
            plan.highlighted
              ? { background: "linear-gradient(135deg, #A855F7, #7C3AED)", boxShadow: "0 0 20px rgba(168,85,247,0.35)" }
              : { background: "rgba(255,255,255,0.05)", border: `1px solid ${plan.accentColor}30` }
          }
        >
          {plan.cta}
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </div>
  );
}

/* ───────────── MAIN EXPORT ───────────── */
export default function PricingSection() {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") as "share" | "direct" | null;

  const [tab, setTab] = useState<"share" | "direct">(
    tabParam === "direct" ? "direct" : "share"
  );
  const [hovered, setHovered] = useState<string | null>(null);

  // Auto-switch tab + scroll when coming from diagnosis success screen
  useEffect(() => {
    if (tabParam === "share" || tabParam === "direct") {
      setTab(tabParam);
      setTimeout(() => {
        const el = document.getElementById("pricing");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 350);
    }
  }, [tabParam]);

  return (
    <section id="pricing" className="relative py-28 lg:py-44 px-6 bg-brand-bg overflow-hidden">
      {/* BG blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute bottom-0 left-1/4 w-96 h-96 rounded-full opacity-5"
          style={{ background: "radial-gradient(circle, #A855F7 0%, transparent 70%)" }}
        />
        <div
          className="absolute top-0 right-1/4 w-80 h-80 rounded-full opacity-5"
          style={{ background: "radial-gradient(circle, #14F1D9 0%, transparent 70%)" }}
        />
      </div>

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-teal mb-5 px-3 py-1 rounded-full border border-brand-teal/30 bg-brand-teal/5">
            Flexible Pricing
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug lg:leading-relaxed">
            두 가지 방식 중<br />
            <span className="gradient-text-brand">당신에게 맞는 플랜을 선택하세요</span>
          </h2>
          <p className="mt-5 text-white/50 font-body text-base max-w-xl mx-auto leading-loose">
            수익을 함께 나누거나, 개발비를 직접 내고 100% 소유하거나 — 두 가지 구조 중 선택하세요.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-14">
          <div
            className="flex p-1 rounded-full gap-1"
            style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
          >
            <button
              onClick={() => setTab("share")}
              className="relative px-7 py-2.5 rounded-full text-sm font-display font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={
                tab === "share"
                  ? { background: "linear-gradient(135deg, #A855F7, #7C3AED)", color: "#fff", boxShadow: "0 0 16px rgba(168,85,247,0.4)" }
                  : { color: "rgba(255,255,255,0.45)" }
              }
            >
              <span className="flex items-center gap-2">
                <i className="ri-hand-coin-line text-sm" />
                수익 쉐어형
              </span>
            </button>
            <button
              onClick={() => setTab("direct")}
              className="relative px-7 py-2.5 rounded-full text-sm font-display font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={
                tab === "direct"
                  ? { background: "linear-gradient(135deg, #14F1D9, #0891b2)", color: "#06080f", boxShadow: "0 0 16px rgba(20,241,217,0.35)" }
                  : { color: "rgba(255,255,255,0.45)" }
              }
            >
              <span className="flex items-center gap-2">
                <i className="ri-money-dollar-circle-line text-sm" />
                개발비 직접결제형
              </span>
            </button>
          </div>
        </div>

        {/* Category description banner */}
        {tab === "share" ? (
          <div
            className="max-w-3xl mx-auto mb-12 flex items-start gap-4 rounded-2xl p-5"
            style={{ background: "rgba(168,85,247,0.07)", border: "1px solid rgba(168,85,247,0.2)" }}
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: "rgba(168,85,247,0.18)" }}>
              <i className="ri-shake-hands-line text-[#A855F7] text-lg" />
            </div>
            <div>
              <p className="text-xs font-display font-bold text-[#A855F7] tracking-widest mb-1.5 uppercase">수익 쉐어형 — Revenue Share</p>
              <p className="text-sm text-white/55 font-body leading-relaxed">
                아르트레너가 일부 또는 전액을 투자하고, 발생한 수익을 약정 비율로 함께 나눕니다.{" "}
                <strong className="text-white/80">초기 비용 부담을 줄이고 싶은 아티스트</strong>에게 적합합니다.
              </p>
            </div>
          </div>
        ) : (
          <div
            className="max-w-3xl mx-auto mb-12 flex items-start gap-4 rounded-2xl p-5"
            style={{ background: "rgba(20,241,217,0.06)", border: "1px solid rgba(20,241,217,0.2)" }}
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: "rgba(20,241,217,0.15)" }}>
              <i className="ri-stack-line text-[#14F1D9] text-lg" />
            </div>
            <div>
              <p className="text-xs font-display font-bold text-[#14F1D9] tracking-widest mb-1.5 uppercase">개발비 직접결제형 — Fixed Fee · 완전 소유</p>
              <p className="text-sm text-white/55 font-body leading-relaxed">
                <strong className="text-white/80">얼마나 크고 복잡한 솔루션을 만드느냐</strong>가 기준입니다. 채널 수·기능 범위·예상 공수에 따라 3단계로 나뉘며, 수익 쉐어 없이 모든 결과물의 완전한 소유권을 갖습니다.
              </p>
            </div>
          </div>
        )}

        {/* Plans Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-start">
          {tab === "share"
            ? shareablePlans.map((plan) => (
                <SharePlanCard key={plan.id} plan={plan} hovered={hovered} onHover={setHovered} />
              ))
            : directPlans.map((plan) => (
                <DirectPlanCard key={plan.id} plan={plan} hovered={hovered} onHover={setHovered} />
              ))}
        </div>

        {/* Bottom notices */}
        <div className="mt-12 lg:mt-16 max-w-4xl mx-auto flex flex-col gap-4">
          {/* Maintenance notice */}
          <div
            className="flex items-start gap-4 rounded-2xl p-5 lg:p-6 border"
            style={{ background: "rgba(255,255,255,0.03)", borderColor: "rgba(255,255,255,0.08)" }}
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: "rgba(255,255,255,0.06)" }}>
              <i className="ri-tools-line text-white/50 text-lg" />
            </div>
            <div>
              <p className="text-xs font-display font-semibold text-white/60 mb-2 tracking-wide uppercase">유지보수 안내 (두 플랜 공통)</p>
              <p className="text-sm text-white/50 font-body leading-loose">
                납품 이후 운영 유지보수(버그 수정, 기능 추가, 서버 관리 등)는{" "}
                <strong className="text-white/75 font-medium">수익 쉐어형 · 개발비 직접결제형 모두 별도 계약</strong>으로 진행됩니다.
                플랜 비용에 포함되지 않습니다.
              </p>
            </div>
          </div>

          {/* OPEX notice */}
          <div
            className="flex items-start gap-4 rounded-2xl p-5 lg:p-6 border"
            style={{ background: "rgba(249,115,22,0.05)", borderColor: "rgba(249,115,22,0.2)" }}
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: "rgba(249,115,22,0.15)" }}>
              <i className="ri-information-line text-brand-orange text-lg" />
            </div>
            <div>
              <p className="text-xs font-display font-semibold text-brand-orange mb-2 tracking-wide uppercase">
                OPEX 투명 정산 안내 (수익 쉐어형 해당)
              </p>
              <p className="text-sm text-white/60 font-body leading-loose">
                <strong className="text-white/80 font-medium">* 서버 비용, 도메인 유지비, 결제 수수료 등 IT 인프라 유지를 위한 필수 운영 실비(OPEX)</strong>
                는 빌더의 마진 없이{" "}
                <span className="text-brand-orange font-semibold">100% 투명하게 실비 정산(Pass-through)</span>으로 청구됩니다. 플랜 수익 쉐어율에 포함되지 않는 별도 항목입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
